import React, {ReactElement, useEffect} from 'react';
import Otpbox from './Otpbox';
import {Otptext} from './Otptext';
import AppHeader from '../../components/appbar/AppBar';
import {
  getStoreCode,
  getStoreInformation,
  getUserType,
} from '../../core/localstorage-data';
import {useHistory} from 'react-router-dom';
import {LANDING_PATH} from '../../routes/route-constants';
import {useAppSelector, useAppDispatch} from '../../redux/hooks';
import {couponPoints, resetCouponAPIResponse} from '../../redux/offerSlice';
import {setTourGuide} from '../../redux/tourGuideSlice';

import {beginLogin, setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';
const LMRotp = (): ReactElement => {
  const navigate = useHistory();
  const UserType = getUserType();
  const storeInformationData = getStoreInformation();
  const dispatch = useAppDispatch();
  const couponPointsDataFromAPI = useAppSelector(couponPoints);
  useEffect(() => {
    setPageName(pageName.loginPage);
    const storeId = getStoreCode();
    if(storeInformationData){
    beginLogin(storeInformationData.store_code,storeInformationData.store_name,storeInformationData.pincode);
    }
    if (UserType === null) {
      navigate.replace(LANDING_PATH);
    }
    if (UserType === 'employee') {
      if (storeInformationData.message === '') {
        localStorage.clear();
        window.location.href = 'employeesignin';
      }
    } else {
      if (storeId === null) {
        navigate.replace(LANDING_PATH);
      }
    }

    if (couponPointsDataFromAPI !== null) {
      dispatch(resetCouponAPIResponse());
    }
    dispatch(setTourGuide(false));
  }, []);
  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="p-4  top-spacing-ipad">
        <Otptext />
        <Otpbox />
      </div>
    </div>
  );
};

export default LMRotp;
